

import Update from "./component/update"
import Header from "./component/header"


function BackUpdate(){


    return(
       <>
          <Header/>

        <Update/>

      
       </>
    )
}

export default BackUpdate